module.exports = __webpack_public_path__ + "static/orion360_sdk_box-51670ef37f30a56f19b2d41d02b3ae49.jpg";